export const TimeArticles_Ar = [
  {
    name: "كم باقي على رمضان 2026",
    link: "/articles-ar/ramadan/",
    description:
      "متى موعد أول أيام شهر رمضان 2026 بالتقويم الهجري والميلادي – متى يبدأ شهر رمضان – العداد التنازلي على شهر رمضان – كم يوم باقي على بداية رشهر مضان المبارك.      ",
      showMain: true,
  },
  {
    name: "كم باقي على عيد الاضحى 2026",
    link: "/articles-ar/eid-adha/",
    description:
      "تجدون هنا العد التنازلي لعيد الاضحى، حيث يمكنكم معرفة كم باقي يوم على عيد الاضحى الكريم.",
      showMain: true,
  },
  {
    name: "كم باقي عيد الفطر 2026",
    link: "/articles-ar/eid-fatr/",
    description:
      "تجدون هنا العد التنازلي لعيد الفطر حيث يمكنكم معرفة كم باقي يوم على عيد الفطر الكريم.",
    showMain: true,
  },
  {
    name: "كم باقي على ليلة النصف من شعبان 2026",
    link: "/articles-ar/shaban/",
    description:
      "تجدون هنا العد التنازلي ليلة النصف من شعبان حيث يمكنكم معرفة كم باقي يوم على ليلة النصف من شعبان.",
    showMain: true,
  },
  {
    name: "كم باقي على راس السنة الهجرية  2026",
    link: "/articles-ar/hijri/",
    description:
      "تجدون هنا العد التنازلي على راس السنة الهجرية الفطر حيث يمكنكم معرفة كم باقي يوم على راس السنة الهجرية.",
    showMain: true,
  },
  {
    name: "كم باقي على عيد الام 2026",
    link: "/articles-ar/motherday/",
    description:
      "تجدون هنا العد التنازلي لعيد الام حيث يمكنكم معرفة كم باقي على عيد الام.",
    showMain: true,
  },
  {
    name: "كم باقي على كاس العالم 2026 ",
    link: "/articles-ar/worldcup/",
    description:
      "تجدون هنا العد التنازلي لبداية كأس العالم 2026 .",
    showMain: true,
  },
  {
    name: "كم باقي على الالمبياد 2028 ",
    link: "/articles-ar/olympics/",
    description:
      "تجدون هنا العد التنازلي لبداية الالمبياد 2028 .",
    showMain: true,
  },
  {
    name: "كم باقي على كاس اسيا 2027 ",
    link: "/articles-ar/asian-cup/",
    description:
      "تجدون هنا العد التنازلي لبداية كاس اسيا 2027 .",
    showMain: true,
  },
  {
    name: "كم باقي على العام الدراسي 2026 في المملكة العربية السعودية",
    link: "/articles-ar/schooldaySA/",
    description:
      "تجدون هنا العد التنازلي للعام الدراسي 2026 في السعودية حيث يمكنكم معرفة كم باقي على العام الدراسي.",
    showMain: true,
  },
];
